import { render, staticRenderFns } from "./OrderPaymentScreen.vue?vue&type=template&id=a0ebe828&scoped=true&"
import script from "./OrderPaymentScreen.vue?vue&type=script&lang=js&"
export * from "./OrderPaymentScreen.vue?vue&type=script&lang=js&"
import style0 from "./OrderPaymentScreen.vue?vue&type=style&index=0&id=a0ebe828&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0ebe828",
  null
  
)

export default component.exports